module.exports = __webpack_public_path__ + "media/images/matchdaySelector__next-927a4a4bbaf39ff5505290d6e564875a.png";